module.exports = __webpack_public_path__ + "static/media/KPMG_logo.svg.9465507c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pic/KPMG_logo.svg.png
// module id = 1169
// module chunks = 0